// src/services/aeropuertos.js
// Aeropuerto por ciudad y aerolínea por número de vuelo, para que el Cotizador llene solo lo
// que se puede deducir (el admin siempre puede cambiarlo a mano).
import { CIUDADES } from './milhasCalc';

const sinTildes = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Ciudad (sin tildes, sin paréntesis ni "+ ómnibus") -> aeropuerto principal.
const POR_CIUDAD = {
  florianopolis: 'FLN', curitiba: 'CWB', 'sao paulo': 'GRU', guarulhos: 'GRU', campinas: 'VCP', congonhas: 'CGH',
  'rio de janeiro': 'GIG', rio: 'GIG', brasilia: 'BSB', salvador: 'SSA', recife: 'REC', fortaleza: 'FOR', natal: 'NAT',
  maceio: 'MCZ', belem: 'BEL', 'porto alegre': 'POA', 'belo horizonte': 'CNF', vitoria: 'VIX', goiania: 'GYN',
  cuiaba: 'CGB', 'boa vista': 'BVB', manaus: 'MAO', 'porto velho': 'PVH', 'rio branco': 'RBR', macapa: 'MCP',
  'sao luis': 'SLZ', teresina: 'THE', 'joao pessoa': 'JPA', aracaju: 'AJU', 'foz do iguacu': 'IGU', navegantes: 'NVT',
  itapema: 'NVT', joinville: 'JOI', londrina: 'LDB', 'campo grande': 'CGR', palmas: 'PMW', santarem: 'STM',
  'porto seguro': 'BPS', ilheus: 'IOS', maringa: 'MGF', chapeco: 'XAP', uberlandia: 'UDI', 'ribeirao preto': 'RAO',
  'caxias do sul': 'CXJ', 'juazeiro do norte': 'JDO',
};

export const nombreCiudadIata = (code) => CIUDADES[String(code || '').toUpperCase()] || '';

// "FLN" -> "Florianópolis (FLN)"
export function etiquetaAeropuerto(code) {
  const c = String(code || '').toUpperCase();
  return c ? `${CIUDADES[c] || c} (${c})` : '';
}

// "Campinas (São Paulo)" -> "VCP" · ciudad que no está en la tabla -> null
export function iataDeCiudad(ciudad) {
  const limpia = sinTildes(String(ciudad || '').replace(/\s*\+.*$/, '').replace(/\s*\(.*?\)/g, ''));
  return POR_CIUDAD[limpia] || null;
}
export const aeropuertoDeCiudad = (ciudad) => { const c = iataDeCiudad(ciudad); return c ? etiquetaAeropuerto(c) : ''; };

// El aeropuerto de salida es Manaus salvo que el vuelo salga de Boa Vista.
export const aeropuertoSalidaDe = (op) => etiquetaAeropuerto(op?.sale_de === 'BVB' ? 'BVB' : 'MAO');

// ── Aerolíneas ───────────────────────────────────────────────────────
const POR_PREFIJO = { AD: 'Azul', G3: 'GOL', LA: 'LATAM', JJ: 'LATAM', '2Z': 'Passaredo', '2Z ': 'Passaredo' };

// "AD4544" · "G3 1234" -> "Azul" · "GOL" · desconocido -> ''
export function aerolineaDeVuelo(numero) {
  const m = String(numero || '').trim().toUpperCase().match(/^([A-Z][A-Z0-9]|[0-9][A-Z])\s*\d{1,4}$/);
  return m ? POR_PREFIJO[m[1]] || '' : '';
}

// "AZUL" -> "Azul" · "gol" -> "GOL" · "Latam Airlines" -> "LATAM"
export function normalizarAerolinea(texto) {
  const t = sinTildes(texto);
  if (!t) return '';
  if (t.includes('azul')) return 'Azul';
  if (t.includes('gol')) return 'GOL';
  if (t.includes('latam')) return 'LATAM';
  return String(texto).trim().replace(/\b\w/g, (c) => c.toUpperCase());
}

export const AEROLINEAS_COMUNES = ['Azul', 'GOL', 'LATAM'];
